import React from 'react'
import { format, differenceInCalendarDays } from "date-fns";

class GridItem extends React.Component {
	getEventDate() {
		const event = this.props.event.schedule
		const date = `${event.orgEventDate} ${event.orgEventTime}`

		let dateStr = ''
		dateStr += format(date, 'dddd')
		dateStr += ' | '
		dateStr += format(date, 'MMM D, YYYY')
		if (event.showTime)
			dateStr += ` | ${format(date, 'hh:mm A')}`

		return dateStr
	}

	render(){
		const event = this.props.event
		const pastDay = differenceInCalendarDays(format(event.schedule.orgEventDate, 'MM/DD/YYYY'), format(Date.now(),'MM/DD/YYYY')) < 0

		return(
			<div 
				className="event-grid-item" 
				tabIndex="0"
				key={event.id} 
				role="link"
				data-url={event.gist.permalink} 
				onKeyPress={ e => e.key === 'Enter' && this.props.gotoEvent(e) }
				onClick={e => this.props.gotoEvent(e)}
				aria-label={ event.gist.title + ' ' + this.getEventDate() }
			>
				<div className="event-image-container">
					<div className="event-image" style={{ backgroundImage: `url(${event.gist.landscapeImageUrl})`}}></div>
				</div>
				<div>
					<div className="title">{event.gist.title}</div>
					<div className="event-date-container">
						<div className="event-date">
							{ this.getEventDate() }
						</div>
						{ event.gist.ticketUrl && !pastDay 
							? <a 
								href={event.gist.ticketUrl} 
								aria-label={`Tickets for ${event.gist.title}`}
								target='_blank' 
								className="event-tickets" 
								onClick={e => e.stopPropagation()}
								>
									Tickets
								</a>
							: <div className="tickets-invisible"></div>
						}
					</div>
				</div>
			</div>
		)
	}
}

export default GridItem;